<template>
  <el-row>
    <el-col :span="24">
      <h4>A Simple FlowChart Libary Base On JsPlumb</h4>
      <a href="https://github.com/lonly197/flowchartjs">Host on GitHub</a>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue